<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<div *ngIf="AccessAllowed" class="p-3 flex flex-column flex-auto">
  <h3 style="margin-bottom: 20px;">Integrations</h3>
  <p style="color: #6c757d; margin-bottom: 30px;">Connect your favorite tools and services to enhance your workflow</p>

  <!-- Search Section -->
  <div style="text-align: right; margin-bottom: 20px;">
    <span class="p-input-icon-left ml-auto" style="margin-right:20px;"> 
      <i class="pi pi-search"></i>
      <input pInputText type="text" placeholder="Search integrations..." 
             [(ngModel)]="searchTerm"
             (input)="onSearchChange()"
             style="height: 50px;padding-left:33px;"/>
    </span>
  </div>

  <!-- Integrations List -->
  <div class="surface-card p-4 shadow-2 border-round">
    <div class="grid" *ngIf="filteredIntegrations.length > 0">
      <div class="col-12" *ngFor="let integration of filteredIntegrations">
        <div class="surface-card border-round p-3 mb-3" style="border: 1px solid #e9ecef; height: 100%; position: relative;">
          <!-- Connect indicator (top right) -->
          <div style="position: absolute; top: 12px; right: 12px; z-index: 1;">
            <p-tag 
              [value]="getIntegrationStatusText(integration.isConnected)" 
              [severity]="getIntegrationStatusColor(integration.isConnected)"
              [icon]="integration.isConnected ? 'pi pi-check' : 'pi pi-times'">
            </p-tag>
          </div>

          <!-- Main content flex layout -->
          <div class="flex" style="height: calc(100% - 80px);">
            <!-- Large logo on left -->
            <div class="flex-none" style="margin-right: 20px;">
              <img 
                [src]="integration.logoUrl" 
                [alt]="integration.name + ' logo'"
                style="width: 300px; height: 150px; border-radius: 8px; border: 1px solid #e9ecef; object-fit: contain; background-color: white; padding: 20px;"
                (error)="onImageError($event)">
            </div>

            <!-- Info content on right -->
            <div class="flex-1" style="display: flex; flex-direction: column;">
              <!-- Name -->
              <h4 style="margin: 0 0 12px 0; font-weight: 600; padding-right: 200px; font-size: 24px;">{{integration.name}}</h4>
              
              <!-- Description -->
              <p style="color: #6c757d; line-height: 1.5; margin-bottom: 20px; font-size: 16px;">{{integration.description}}</p>
            </div>
          </div>

          <!-- Buttons at bottom right -->
          <div style="position: absolute; bottom: 12px; right: 12px; display: flex; gap: 12px;">
            <button pButton 
              [label]="getIntegrationButtonText(integration.isConnected)"
              [severity]="integration.isConnected ? 'danger' : 'success'"
              [icon]="integration.isConnected ? 'pi pi-times' : 'pi pi-plus'"
              (click)="handleIntegration(integration)"
              style="height: 48px; font-size: 14px; min-width: 120px;"
              class="p-button">
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="filteredIntegrations.length === 0" class="text-center" style="padding: 60px 20px;">
      <i class="pi pi-search" style="font-size: 48px; color: #dee2e6; margin-bottom: 16px; display: block;"></i>
      <h4 style="color: #6c757d; margin-bottom: 8px;">No integrations found</h4>
      <p style="color: #adb5bd;">Try adjusting your search terms</p>
    </div>
  </div>
</div>